/* eslint-disable no-console */
import React from "react";

import Button from "Components/Form/Button/index";
import Modal from "Components/Generic/Modal";

interface TeamCreateModalProps {
  open: boolean;
  handleClose: () => void;
}

export const TeamCreateModal = (props: TeamCreateModalProps) => {
  const { open, handleClose } = props;

  const handleCreate = () => {
    handleClose();
  };

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title="Create New Task"
      showActionButtons
      actionButtonProps={{
        onCancel: handleClose,
      }}
      customRightButtons={
        <Button onClick={handleCreate} color="primary">
          Create
        </Button>
      }
    >
      <p>modal content </p>
    </Modal>
  );
};
